import styled from "styled-components"
import {ButtonToolbar, Dropdown as BootstrapDropdown} from "react-bootstrap"

import {threePxShadowBigBlur} from "@irati/ui/src/global/elevation"
import Button from "@irati/ui/src/Button"
import {Hr} from "@irati/ui/src/Layout"

interface DropdownProps {
  open?: boolean
}

export const DropdownMenu = styled(BootstrapDropdown.Menu)`
  border: none;
  padding: 10px;
  ${threePxShadowBigBlur};
  margin-top: 10px;
`

export const ToggleButton = styled(Button)<DropdownProps>`
  padding: 10px;
  ${({open, theme}) => open && `box-shadow: 0 0 0 1px ${theme.colors.greys.mediumDark};`}
`
export const StyledButtonToolbar = styled(ButtonToolbar)`
  margin-left: 0;
`

export const StyledHr = styled(Hr)`
  margin: 10px 0;
`
